import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const UnhappyFace = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path id="Vector" d="M12.3957 13.1253C11.993 13.1253 11.6665 12.7989 11.6665 12.3962C11.6665 11.9935 11.993 11.667 12.3957 11.667C12.7984 11.667 13.1248 11.9935 13.1248 12.3962C13.1248 12.7989 12.7984 13.1253 12.3957 13.1253Z" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path id="Vector_2" d="M22.6042 13.1253C22.2015 13.1253 21.875 12.7989 21.875 12.3962C21.875 11.9935 22.2015 11.667 22.6042 11.667C23.0068 11.667 23.3333 11.9935 23.3333 12.3962C23.3333 12.7989 23.0068 13.1253 22.6042 13.1253Z" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path id="Vector_3" d="M17.4998 32.0837C25.5539 32.0837 32.0832 25.5544 32.0832 17.5003C32.0832 9.44617 25.5539 2.91699 17.4998 2.91699C9.44568 2.91699 2.9165 9.44617 2.9165 17.5003C2.9165 25.5544 9.44568 32.0837 17.4998 32.0837Z" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path id="Vector_4" d="M10.9375 22.6042C10.9375 22.6042 13.125 19.6875 17.5 19.6875C21.875 19.6875 24.0625 22.6042 24.0625 22.6042" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} viewBox="0 0 35 35" variant="outline">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { UnhappyFace };